<form [formGroup]="form" class="flex flex-col">
    <section aria-labelledby="general-certification-statements">
        <h3 class="application-section-header">
            General Certification Statements
        </h3>
        <hr class="mb-4" />
        <ol class="mx-3">
            @for (statement of statements; track i; let i = $index) {
                <li class="flex mb-4">
                    <span class="text-base leading-4 mr-4">{{ i + 1 }}</span>
                    <span class="text-xs text-tertiary-800">{{
                        statement
                    }}</span>
                </li>
            }
        </ol>
    </section>

    <section aria-labelledby="signature">
        <h3 class="application-section-header flex items-center">
            <span>Signature</span>
            <app-hover-tooltip
                class="ml-2"
                [moreInfo]="true"
                [message]="messages.signatureSection"
            ></app-hover-tooltip>
        </h3>
        <hr class="mb-4" />
        <div class="flex flex-wrap">
            <app-application-form-field fieldNumber="60" class="xl:w-10/12">
                <div class="flex flex-wrap w-full">
                    <div class="w-full lg:pr-4 mb-4 lg:w-4/12 lg:mb-0">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>First Name</mat-label>
                            <input
                                title="First Name"
                                matInput
                                formControlName="certifierFirstName"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                                maxLength="20"
                            />
                        </mat-form-field>
                    </div>
                    <div class="w-full lg:pr-4 mb-4 lg:w-2/12 lg:mb-0">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Middle Initial</mat-label>
                            <input
                                title="Middle Initial"
                                matInput
                                formControlName="certifierMiddleInitial"
                                [appRegexInput]="
                                    regExPattern.AlphabeticalCharacters
                                "
                                maxLength="1"
                            />
                        </mat-form-field>
                    </div>
                    <div class="w-full lg:pr-4 mb-4 lg:w-4/12 lg:mb-0">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Last Name</mat-label>
                            <input
                                title="Last Name"
                                matInput
                                formControlName="certifierLastName"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                                maxLength="20"
                            />
                        </mat-form-field>
                    </div>
                    <div class="w-full mb-4 lg:w-2/12 lg:mb-0">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Suffix</mat-label>
                            <input
                                title="Suffix"
                                matInput
                                formControlName="certifierSuffix"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                                maxLength="3"
                            />
                        </mat-form-field>
                    </div>
                </div>
            </app-application-form-field>
            <app-application-form-field
                fieldNumber="61"
                class="w-full xl:w-5/12"
            >
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Title</mat-label>
                    <input
                        title="Title"
                        matInput
                        formControlName="certifierTitle"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        maxLength="40"
                    />
                </mat-form-field>
            </app-application-form-field>

            <mat-form-field
                appearance="outline"
                class="w-full xl:w-8/12 ml-[49px]"
            >
                <mat-label>Electronic Signature</mat-label>
                <input
                    title="Signature"
                    matInput
                    formControlName="certifierSignature"
                    class="!font-script !text-xl"
                />
            </mat-form-field>

            <app-application-form-field
                fieldNumber="62"
                class="w-full xl:w-5/12"
            >
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Date</mat-label>
                    <input
                        title="Date"
                        matInput
                        formControlName="certifierSignatureDate"
                    />
                </mat-form-field>
            </app-application-form-field>
        </div>
        <div class="ml-[49px]" [innerHtml]="messages.footer"></div>
    </section>
</form>
